import { useAccommodationsConsoleHotelsSortOrderQuery } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';
import { addAction, addError } from '@shared/utils/logger';

export const useAccommodationsSortOrder = () => {
  const { eventHandle } = useEventInfo();

  const { data: pageContainerData, loading } = useAccommodationsConsoleHotelsSortOrderQuery({
    variables: {
      payload: {
        eventName: eventHandle || '',
        pageSlug: 'accommodations',
      },
    },
    onCompleted: data => {
      if (data?.pageContainerBySlug?.components?.[0]?.__typename === 'TravelMapComponent' && !data?.pageContainerBySlug?.components?.[0]?.blockOrdering?.length) {
        addAction('Accommodations block ordering is empty (AccommodationsConsole)', {
          context: 'blockOrdering',
          eventHandle,
        });
      }
    },
    onError: error => {
      addError(error, {
        source: 'Accommodations block ordering api failed (AccommodationsConsole)',
        context: 'blockOrdering',
        errorMessage: error.message,
        eventHandle,
      });
    },
    skip: !eventHandle,
    fetchPolicy: 'cache-and-network',
    batchMode: 'fast',
  });

  return {
    loading,
    pageContainerBySlug:
      pageContainerData?.pageContainerBySlug?.components?.[0]?.__typename === 'TravelMapComponent' ? pageContainerData?.pageContainerBySlug?.components?.[0] : null,
  };
};
